export default __webpack_public_path__ + "static/healing-offer-7b2b6255b4e78475be995625e8b2f14a.png";